// extracted by mini-css-extract-plugin
export default {"line":"LineSeparator_line__TP-zZ"};